export class RecoverPasswordReq {
    id: string;
    newPassword: string;
    confirmPassword: string;
}


// WEBPACK FOOTER //
// ./src/app/shared/recover-password/recover-password-req.ts